import { isMobileDevice, updateNavBarPosition } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const useMobileNavBarEffect = (calendarView, selectedDate, orderSummaryModal) => {
    useEffectWithErrorLogging(() => {
        if (isMobileDevice()) {
            updateNavBarPosition('unset', true);
        }
    }, [calendarView, selectedDate, orderSummaryModal]);
};

export default useMobileNavBarEffect;
